import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconTrash = ({ color = 'currentColor', size = 'micro', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" size={size} {...props}>
        <StyledStrokedGroup color={color} strokeLinecap="round" strokeLinejoin="round">
            <StyledPath
                color="none"
                d="M1 3h14M9.5 1h-3a1 1 0 0 0-1 1v1h5V2a1 1 0 0 0-1-1ZM6.5 11.5v-5M9.5 11.5v-5M12.577 14.083a1 1 0 0 1-.997.917H4.42a1 1 0 0 1-.996-.917L2.5 3h11l-.923 11.083Z"
            />
        </StyledStrokedGroup>
    </StyledSvg>
);
